import * as React from "react"
import "./style_5.scss"
import TextWithLinksParser from "../../TextWithLinksParser"

export default function ProductContentStyle5({ items }) {
    return (items?.map(({ count, title, image, description }, index) => (
        <div key={index}
            className={`product-content style_5`}
        >
            <div className={`content-block-info`}>
                {
                    count && title && image ? (
                        <div className="info">
                            <p className="title">{count} {title}</p>
                            <img src={image} alt="" />
                        </div>
                    ) : null
                }
                {
                    description ? (
                        <div className="description">
                            <TextWithLinksParser text={description} />
                        </div>
                    ) : null
                }
            </div>
        </div>
    ))
    )
}
